<template>
  <div class="wrap" id="mail">
    <!-- 站内信列表页 -->
    <div class="title">个人消息</div>
    <div id="mailPage">
      <div v-if="dataList.length != 0" class="main_content">
        <div v-for="item in dataList" :key="item.inMsgId" class="item_mail">
          <div v-if="item.type == 1" class="dec">
            <span class="circle"></span>
            <p>
              根据测试订单交易风险控制管理细则，
              您账户的资金风险率高于100%，在电话通知和短信提醒后，未能自行减少订货量或尽快补足可用资金，现于{{
                item.tradeDay
              }}将您{{ item.commodityInfo
              }}{{ item.bsFlag == 1 ? '买' : '卖' }}方向的{{
                item.quantity
              }}手持仓以{{ item.price }}在{{
                item.transferTime | dateFormate
              }}进行代为转让操作，请悉知。
            </p>
          </div>
          <div v-else class="dec">
            <span class="circle"></span>
            <p v-html="item.note">
            </p>
          </div>
          <p class="time">{{ item.createTime | dateFormate }}</p>
        </div>
      </div>
    </div>
    <div v-if="dataList.length == 0" class="main_content noImg">
      <div
        class="no-data-img"
        style="margin: 0 auto; width: 120px; height: 100px;"
      >
        <img
          src="../../assets/images/no_data.png"
          alt=""
          style="width: 100%;"
        >
      </div>  
      <span>暂无数据</span>
    </div>
    <div style="margin-bottom: 210px" v-if="dataList.length != 0">
      <el-pagination
        class="paginationPage"
        popper-class="_popStyle"
        :current-page="pageData.currentPage"
        :page-sizes="pageData.pageSizes"
        :page-size="pageData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
/*global http protocolTrans protocol */
export default {
  data() {
    return {
      dataList: [],
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.isReadFlag()
  },
  methods: {
    // 查询站内信信息
    isReadFlag() {
      protocolTrans.param_transferMsgInfo.param.size = this.pageData.pageSize
      protocolTrans.param_transferMsgInfo.param.page =
        this.pageData.currentPage - 1
      protocolTrans.param_transferMsgInfo.param.readFlag = null // 查看所有站内信
      http.postFront(protocolTrans.param_transferMsgInfo).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value.content) {
            this.dataList = value.content
            this.pageData.total = value.totalElements
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.isReadFlag()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.isReadFlag()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-pagination .el-select .el-input .el-input__inner,
/deep/.el-pagination button:disabled,
/deep/ .el-pagination .btn-prev,
/deep/ .el-pagination .btn-next,
/deep/ .el-pagination__editor.el-input .el-input__inner
,/deep/ .el-pagination .el-select .el-input .el-input__inner {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}
/deep/ .el-pagination .el-select .el-input .el-input__inner,
/deep/ .el-pagination__editor.el-input .el-input__inner {
    background-color: transparent !important;
    border-color: #DCDFE6 !important;
}

.title {
  width: 100%;
  padding-bottom: 44px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
/deep/ .el-pagination button:disabled,/deep/ .el-pagination .btn-prev,/deep/ .el-pagination .btn-next,/deep/ .el-pager li,/deep/ .el-pagination__editor.el-input .el-input__inner,/deep/ .el-pager li{
  background-color: transparent;
}
.main_content {
  min-height: calc(100vh - 305px);
}
.noImg{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.el-pagination{
  text-align: center;
}
.wrap{
  background-color: #ffffff;
  min-height: 100vh !important;
  height: calc(100vh - 60px);
  overflow: scroll;
  padding: 95px 40px 0;
  box-sizing: border-box;
}
#mailPage {
  .item_mail {
    padding: 23px 0 24px 99px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .dec {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      display: flex;
      align-items: flex-start;
    }
    .time {
      font-family: Source Han Sans SC;
      font-weight: 200;
      font-size: 12px;
      color: #999999;
      padding-left: 16px;
      margin-top: 8px;
    }
    .circle {
      margin-top: 5px;
      display: inline-block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #fa4d55;
      margin-right: 10px;
    }
  }
  .item_mail:last-child {
    // border-bottom: none;
  }
}
</style>
